import React from 'react';
import './MapZoomControls.css';

function IconBrazil() {
  return (
    <svg width="22" height="16" viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg">
      <rect width="22" height="16" rx="2" fill="#009C3B" />
      <polygon points="11,1.5 20.5,8 11,14.5 1.5,8" fill="#FFDF00" />
      <circle cx="11" cy="8" r="3.5" fill="#002776" />
      <path d="M7.6 8.6 Q11 7.2 14.4 8.6" stroke="white" strokeWidth="0.9" fill="none" />
    </svg>
  );
}

function IconPlus() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function IconMinus() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function MapZoomControls({ mapRef }) {
  function handleResetNorth() {
    mapRef.current?.setView([-15.7801, -47.9292], 4, { animate: true });
  }

  function handleZoomIn() {
    mapRef.current?.zoomIn();
  }

  function handleZoomOut() {
    mapRef.current?.zoomOut();
  }

  return (
    <div className="map-zoom-controls">
      <button
        className="map-toolbar-btn"
        onClick={handleResetNorth}
        title="Centralizar no Brasil"
      >
        <IconBrazil />
      </button>

      <div className="map-toolbar-divider" />

      <button
        className="map-toolbar-btn"
        onClick={handleZoomIn}
        title="Ampliar"
      >
        <IconPlus />
      </button>

      <button
        className="map-toolbar-btn"
        onClick={handleZoomOut}
        title="Reduzir"
      >
        <IconMinus />
      </button>
    </div>
  );
}

export default MapZoomControls;
